import { Button, type ButtonProps } from "components/button";
import { Link, type LinkProps } from "@tanstack/react-router";
import { useBackNavigation } from "hooks/useBackNavigation";
import { cn } from "utils";

interface BackButtonProps
  extends Omit<ButtonProps, "icon" | "variant" | "asChild"> {
  to?: LinkProps["to"];
  label?: string;
  fallbackTo?: LinkProps["to"];
  fallbackLabel?: string;
}

export const BackButton = ({
  to,
  label,
  fallbackTo,
  fallbackLabel,
  className,
  ...rest
}: BackButtonProps) => {
  const backNavigation = useBackNavigation();

  const finalTo = to ?? backNavigation?.route ?? fallbackTo;
  const finalLabel = label ?? backNavigation?.label ?? fallbackLabel;

  if (!finalTo || !finalLabel) return null;

  return (
    <Button
      asChild
      variant="ghost"
      icon="arrow-left"
      label={finalLabel}
      className={cn("px-0", className)}
      {...rest}
    >
      <Link to={finalTo} />
    </Button>
  );
};
